<template>
  <v-toolbar id="core-toolbar" flat prominent>
    <div class="v-toolbar-title">
      <v-toolbar-title class="white--text font-weight-light">
        <router-link to="/">
          <img id="logo" src="/logo.svg" />
        </router-link>
      </v-toolbar-title>
    </div>
    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-chip color="tertiary" text-color="white" class="hidden-xs-only">
          <v-avatar>
            <v-icon>mdi-account-circle</v-icon>
          </v-avatar>
          {{ user }} logged
        </v-chip>

        <router-link v-ripple class="toolbar-items" to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link>
        <router-link v-ripple class="toolbar-items" to="/adspaces">
          <v-icon color="tertiary">mdi-domain</v-icon>
        </router-link>
        <router-link v-ripple class="toolbar-items" to="/api-keys">
          <v-icon color="tertiary">mdi-folder-key-network</v-icon>
        </router-link>
        <router-link v-ripple class="toolbar-items" to="/multipliers">
          <v-icon color="tertiary">mdi-multiplication</v-icon>
        </router-link>
        <router-link v-ripple class="toolbar-items" to="/input">
          <v-icon color="tertiary">mdi-file-upload-outline</v-icon>
        </router-link>
        <v-spacer />
        <button v-on:click="logout()" class="toolbar-items">
          <v-icon color="tertiary">mdi-logout</v-icon>
        </button>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    responsive: true,
    responsiveInput: false
  }),
  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },
  computed: mapState({
    user: state => state.fullname
  }),
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    logout () {
      return this.$store.dispatch('logout')
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>
